export default "__VITE_ASSET__CTErI6Yo__"